import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bold", "children", "chronicle", "className", "color", "component", "gotham", "italic", "level", "light", "semanticLevel", "size", "uppercase", "TypeComponent"];
import "core-js/modules/es6.string.bold.js";
// TODO: remove this component in Currency v3.
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { Type } from '../Type/Type';
var levelSizeMap = {
  1: 5,
  2: 4,
  3: 4,
  4: 3,
  5: 3
};
var levelComponentMap = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5'
};
var sizeComponentMap = {
  1: 'h5',
  2: 'h4',
  3: 'h3',
  4: 'h2',
  5: 'h1'
};

var deriveHeadingSize = function deriveHeadingSize(_ref) {
  var level = _ref.level,
      size = _ref.size;

  if (size) {
    return size;
  }

  if (level) {
    var levelSize = levelSizeMap[level];

    if (!levelSize) {
      throw new Error('Invalid heading level');
    }

    return levelSize;
  }

  throw new Error('Must provide heading size or level');
};

var deriveHeadingComponent = function deriveHeadingComponent(_ref2) {
  var component = _ref2.component,
      semanticLevel = _ref2.semanticLevel,
      level = _ref2.level,
      size = _ref2.size;

  if (component) {
    return component;
  }

  if (semanticLevel || level) {
    var levelComponent = levelComponentMap[semanticLevel || level];

    if (!levelComponent) {
      throw new Error('Invalid heading level');
    }

    return levelComponent;
  }

  if (size) {
    var sizeComponent = sizeComponentMap[size];

    if (!sizeComponent) {
      throw new Error('Invalid heading level');
    }

    return sizeComponent;
  }

  throw new Error('Must provide heading size or level');
};
/**
 * Deprecated. Use <Title> instead.
 *
 * @deprecated
 */


export var Heading = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var bold = props.bold,
      children = props.children,
      chronicle = props.chronicle,
      className = props.className,
      color = props.color,
      component = props.component,
      gotham = props.gotham,
      italic = props.italic,
      level = props.level,
      light = props.light,
      semanticLevel = props.semanticLevel,
      size = props.size,
      uppercase = props.uppercase,
      TypeComponent = props.TypeComponent,
      otherProps = _objectWithoutProperties(props, _excluded);

  useDeprecatedComponentWarning({
    component: 'Heading',
    migration: 'Use <Title> and <Text> components.'
  });
  return /*#__PURE__*/React.createElement(TypeComponent, _extends({
    size: deriveHeadingSize({
      level: level,
      size: size
    }),
    gotham: gotham,
    chronicle: chronicle,
    bold: bold,
    italic: italic,
    uppercase: uppercase,
    light: light,
    color: color,
    component: deriveHeadingComponent({
      component: component,
      semanticLevel: semanticLevel,
      level: level,
      size: size
    }),
    className: className,
    ref: ref
  }, otherProps), children);
});
Heading.displayName = 'Heading';
Heading.defaultProps = {
  bold: true,
  children: null,
  chronicle: false,
  className: null,
  color: null,
  component: null,
  gotham: false,
  italic: false,
  level: 1,
  light: false,
  semanticLevel: null,
  size: null,
  uppercase: false,
  TypeComponent: Type
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Heading.propTypes = {
    children: PropTypes.node,

    /**
     * Set the heading level. Also determines what component to use by default
     * (h1-h5).
     */
    level: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /**
     * Font size, 1=smallest, 5=biggest. Derived from level if not specified.
     */
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Use Gotham font. Font is inherited if not specified. */
    gotham: PropTypes.bool,

    /** Use Chronicle font. Font is inherited if not specified. */
    chronicle: PropTypes.bool,

    /** Bold styling. */
    bold: PropTypes.bool,

    /** Italic styling. */
    italic: PropTypes.bool,

    /** Turn text uppercase and spaces out letters. */
    uppercase: PropTypes.bool,

    /** Set text to a light gray color. Specifically "neutral-darker" defined in base-styles. */
    light: PropTypes.bool,

    /** Set text to a color defined by base-styles (overrides light). */
    color: PropTypes.string,

    /**
     * Use a custom component instead of the default h1-h5 html components.
     */
    // eslint-disable-next-line react/forbid-prop-types
    component: PropTypes.any,
    className: PropTypes.string,

    /**
     * This is deprecated and here for backwards-compatibility. Use the
     * `component` prop stead. Sets the heading semantic level and determines
     * what h1-h5 element to use (separately from the visual style).
     *
     * @deprecated
     */
    semanticLevel: PropTypes.number,

    /**
     * INTERNAL: the specific `<Type />` component to render into.
     */
    TypeComponent: PropTypes.elementType
  };
}